import { render, staticRenderFns } from "./PosMainMenu.vue?vue&type=template&id=ab069058"
import script from "./PosMainMenu.vue?vue&type=script&lang=js"
export * from "./PosMainMenu.vue?vue&type=script&lang=js"
import style0 from "./PosMainMenu.vue?vue&type=style&index=0&id=ab069058&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports